module.exports = __webpack_public_path__ + "img/trash-2.847189fc.svg";